export default {
  add_items: 'Add items',
  remove_items: 'Remove items',
  place_order: 'Place order',
  pay_now: 'Pay now',

  terms:
    'By placing your order, you agree to our <TermsLink>Terms and Conditions</TermsLink> and our <PrivacyPolicyLink>Privacy Policy</PrivacyPolicyLink>.',

  error_messages: {
    payment_unsuccessful: {
      title: 'Payment failed',
      description: 'Please check your payment information and try again.',
    },
  },
};
